import { render } from "./ProductUomDisplay.vue?vue&type=template&id=4d4efa98"
import script from "./ProductUomDisplay.vue?vue&type=script&lang=js"
export * from "./ProductUomDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__